import type { RouteRecordRaw } from 'vue-router';
import { AdoptionRoutes } from './modules/Adoption';
import { AnimalRoutes } from './modules/Animal';
import { AnimalProfileRoutes } from './modules/AnimalProfile';
import { CommunitySupportRoutes } from './modules/CommunitySupport';
import { EquipmentRentalRoutes } from './modules/EquipmentRental';
import { FieldServiceRoutes } from './modules/FieldService';
import { FormsAndApplicationsRoutes } from './modules/FormsAndApplication';
import { FosterRoutes } from './modules/Foster';
import { InfoRoutes } from './modules/Info';
import { KennelManagerRoutes } from './modules/KennelManager';
import { LostAndFoundRoutes } from './modules/LostAndFound';
import { PartnerRoutes } from './modules/Partner';
import { PeopleRoutes } from './modules/People';
import { ProductsAndServicesRoutes } from './modules/ProductsAndServices';
import { RehomingRoutes } from './modules/Rehoming';
import { ReportRoutes } from './modules/Report';
import { ReportTemplatesRoutes } from './modules/ReportTemplates';
import { SettingsRoutes } from './modules/Settings';
import ShoppingCartRoutesModule from './modules/ShoppingCart/routes';
import { StaffRoutes } from './modules/Staff';
import { StatsRoutes } from './modules/Stats';
import { TnvrRoutes } from './modules/Tnvr';
import { TransportRoutes } from './modules/Transport';

export default <RouteRecordRaw[]>[
  {
    path: '/shelter',
    name: 'shelter',
    component: () => import('../../../layouts/TheMainLayout/TheMainLayout.vue'),
    redirect: () => '/shelter/animals/in-care',
    children: [
      ...AdoptionRoutes,
      ...AnimalProfileRoutes,
      ...AnimalRoutes,
      ...ShoppingCartRoutesModule,
      ...CommunitySupportRoutes,
      ...EquipmentRentalRoutes,
      ...FieldServiceRoutes,
      ...FormsAndApplicationsRoutes,
      ...FosterRoutes,
      ...InfoRoutes,
      ...KennelManagerRoutes,
      ...LostAndFoundRoutes,
      ...PartnerRoutes,
      ...PeopleRoutes,
      ...ProductsAndServicesRoutes,
      ...RehomingRoutes,
      ...ReportRoutes,
      ...ReportTemplatesRoutes,
      ...SettingsRoutes,
      ...StaffRoutes,
      ...StatsRoutes,
      ...TnvrRoutes,
      ...TransportRoutes,
      {
        path: 'not-found',
        name: 'not-found',
        component: () => import('./views/NotFound.view.vue'),
      },
      {
        path: '/shelter/animal-profile/:id', // TODO: move route to correct domain
        redirect: '/shelter/',
      },
      {
        path: '/shelter/people/profile/:id', // TODO: move route to correct domain
        redirect: '/shelter/',
      },
    ],
  },
];
